// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Dark Theme Table Container */
.NewsLetterPage_container__v8Ayy {
    display: flex;
    justify-content: center;
    margin-top: 2rem;
  }
  /* Responsive Table Wrapper */
  .NewsLetterPage_tableWrapper__9rKcl {
    width: 100%;
    max-width: 900px;
    overflow-x: auto;
    box-shadow: 0px 0px 24px 2px rgb(83 79 93 / 44%);
    border-radius: 8px;
    background-color: rgba(43, 42, 42, 0.8);
    max-width: 1200px;
  }
  /* Table */
  .NewsLetterPage_table__c-DqW {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0;
    min-width: 300px;
    color: #ffffff;
  }
  /* Table Headers */
  .NewsLetterPage_headerRow__BRokS {
    background-color: #333;
    color: #ffffff;
  }
  .NewsLetterPage_headerCell__-yoJR {
    padding: 16px;
    font-size: 18px;
    text-transform: uppercase;
    border-bottom: 3px solid #4b4b4b;
    text-align: center;
    font-weight: bold;
    letter-spacing: 1px;
  }
   /* Table Rows */
  .NewsLetterPage_bodyRow__ssiqc {
    transition: background-color 0.2s ease;
  }
  .NewsLetterPage_oddRow__491Lp {
    background-color: #252525;
  }
  .NewsLetterPage_evenRow__8GPRv {
    background-color: #1e1e1e;
  }
  .NewsLetterPage_bodyRow__ssiqc:hover {
    background-color: #3a3a3a !important;
  }
  /* Table Cells */
  .NewsLetterPage_bodyCell__asTp2 {
    padding: 14px;
    border-bottom: 1px solid #444;
    text-align: center;
  }
  .NewsLetterPage_noData__2PyoO {
    text-align: center;
    padding: 30px;
    color: #aaa;
    font-style: italic;
  }
  /* Subscription Status Buttons */
  .NewsLetterPage_statusButton__p0IGF {
    font-weight: 500;
    padding: 8px 16px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.2s ease;
    min-width: 120px;
  }
  .NewsLetterPage_subscribed__fyOmJ {
    background-color: #2e7d32; /* Green for subscribed */
    color: white;
  }
  .NewsLetterPage_subscribed__fyOmJ:hover {
    background-color: #1b5e20;
    box-shadow: 0 2px 8px rgba(46, 125, 50, 0.4);
  }
  .NewsLetterPage_unsubscribed__9Msq2 {
    background-color: #c62828; /* Red for unsubscribed */
    color: white;
  }
  .NewsLetterPage_unsubscribed__9Msq2:hover {
    background-color: #b71c1c;
    box-shadow: 0 2px 8px rgba(198, 40, 40, 0.4);
  }
    /* Pagination Controls */
  .NewsLetterPage_paginationContainer__NPmSb {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 20px 0;
    gap: 15px;
    padding-bottom: 10px;
  }
  .NewsLetterPage_pageInfo__PYARB {
    color: #fff;
    font-size: 14px;
    min-width: 100px;
    text-align: center;
  }
  .NewsLetterPage_pageButton__r9QoK {
    background-color: #3a3a3a;
    color: white;
    border: none;
    padding: 10px 20px;
    cursor: pointer;
    border-radius: 5px;
    transition: all 0.2s ease;
    font-weight: 500;
    min-width: 100px;
  }
  .NewsLetterPage_pageButton__r9QoK:hover:not(.NewsLetterPage_disabled__APyyN) {
    background-color: #555;
    transform: translateY(-2px);
  }
  .NewsLetterPage_pageButton__r9QoK:active:not(.NewsLetterPage_disabled__APyyN) {
    transform: translateY(0);
  }
  .NewsLetterPage_pageButton__r9QoK.NewsLetterPage_disabled__APyyN {
    background-color: #1a1a1a;
    cursor: not-allowed;
    opacity: 0.5;
  }
  
  /* Responsive Scroll for Small Screens */
  @media (max-width: 768px) {
    .NewsLetterPage_headerCell__-yoJR,
    .NewsLetterPage_bodyCell__asTp2 {
      font-size: 14px;
      padding: 10px;
    }
  
    .NewsLetterPage_tableWrapper__9rKcl {
      border-radius: 0;
      box-shadow: none;
      margin: 0 -10px;
    }
  
    .NewsLetterPage_paginationContainer__NPmSb {
      flex-wrap: wrap;
      justify-content: space-between;
      padding: 0 10px 15px;
    }
    
    .NewsLetterPage_pageButton__r9QoK {
      min-width: 80px;
      padding: 8px 12px;
    }
    
    .NewsLetterPage_statusButton__p0IGF {
      min-width: 100px;
      padding: 6px 12px;
      font-size: 13px;
    }
  }
  
  @media (max-width: 480px) {
    .NewsLetterPage_headerCell__-yoJR {
      font-size: 13px;
      padding: 8px;
    }
    .NewsLetterPage_statusButton__p0IGF {
      min-width: 90px;
      padding: 5px 8px;
    }
  }`, "",{"version":3,"sources":["webpack://./src/admin/pages/newsletter/NewsLetterPage.module.css"],"names":[],"mappings":"AAAA,+BAA+B;AAC/B;IACI,aAAa;IACb,uBAAuB;IACvB,gBAAgB;EAClB;EACA,6BAA6B;EAC7B;IACE,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,gDAAgD;IAChD,kBAAkB;IAClB,uCAAuC;IACvC,iBAAiB;EACnB;EACA,UAAU;EACV;IACE,WAAW;IACX,yBAAyB;IACzB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;EAChB;EACA,kBAAkB;EAClB;IACE,sBAAsB;IACtB,cAAc;EAChB;EACA;IACE,aAAa;IACb,eAAe;IACf,yBAAyB;IACzB,gCAAgC;IAChC,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;EACrB;GACC,eAAe;EAChB;IACE,sCAAsC;EACxC;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,oCAAoC;EACtC;EACA,gBAAgB;EAChB;IACE,aAAa;IACb,6BAA6B;IAC7B,kBAAkB;EACpB;EACA;IACE,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,kBAAkB;EACpB;EACA,gCAAgC;EAChC;IACE,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,gBAAgB;EAClB;EACA;IACE,yBAAyB,EAAE,yBAAyB;IACpD,YAAY;EACd;EACA;IACE,yBAAyB;IACzB,4CAA4C;EAC9C;EACA;IACE,yBAAyB,EAAE,yBAAyB;IACpD,YAAY;EACd;EACA;IACE,yBAAyB;IACzB,4CAA4C;EAC9C;IACE,wBAAwB;EAC1B;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;IACd,SAAS;IACT,oBAAoB;EACtB;EACA;IACE,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,kBAAkB;EACpB;EACA;IACE,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,yBAAyB;IACzB,gBAAgB;IAChB,gBAAgB;EAClB;EACA;IACE,sBAAsB;IACtB,2BAA2B;EAC7B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;EACd;;EAEA,wCAAwC;EACxC;IACE;;MAEE,eAAe;MACf,aAAa;IACf;;IAEA;MACE,gBAAgB;MAChB,gBAAgB;MAChB,eAAe;IACjB;;IAEA;MACE,eAAe;MACf,8BAA8B;MAC9B,oBAAoB;IACtB;;IAEA;MACE,eAAe;MACf,iBAAiB;IACnB;;IAEA;MACE,gBAAgB;MAChB,iBAAiB;MACjB,eAAe;IACjB;EACF;;EAEA;IACE;MACE,eAAe;MACf,YAAY;IACd;IACA;MACE,eAAe;MACf,gBAAgB;IAClB;EACF","sourcesContent":["/* Dark Theme Table Container */\n.container {\n    display: flex;\n    justify-content: center;\n    margin-top: 2rem;\n  }\n  /* Responsive Table Wrapper */\n  .tableWrapper {\n    width: 100%;\n    max-width: 900px;\n    overflow-x: auto;\n    box-shadow: 0px 0px 24px 2px rgb(83 79 93 / 44%);\n    border-radius: 8px;\n    background-color: rgba(43, 42, 42, 0.8);\n    max-width: 1200px;\n  }\n  /* Table */\n  .table {\n    width: 100%;\n    border-collapse: separate;\n    border-spacing: 0;\n    min-width: 300px;\n    color: #ffffff;\n  }\n  /* Table Headers */\n  .headerRow {\n    background-color: #333;\n    color: #ffffff;\n  }\n  .headerCell {\n    padding: 16px;\n    font-size: 18px;\n    text-transform: uppercase;\n    border-bottom: 3px solid #4b4b4b;\n    text-align: center;\n    font-weight: bold;\n    letter-spacing: 1px;\n  }\n   /* Table Rows */\n  .bodyRow {\n    transition: background-color 0.2s ease;\n  }\n  .oddRow {\n    background-color: #252525;\n  }\n  .evenRow {\n    background-color: #1e1e1e;\n  }\n  .bodyRow:hover {\n    background-color: #3a3a3a !important;\n  }\n  /* Table Cells */\n  .bodyCell {\n    padding: 14px;\n    border-bottom: 1px solid #444;\n    text-align: center;\n  }\n  .noData {\n    text-align: center;\n    padding: 30px;\n    color: #aaa;\n    font-style: italic;\n  }\n  /* Subscription Status Buttons */\n  .statusButton {\n    font-weight: 500;\n    padding: 8px 16px;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    min-width: 120px;\n  }\n  .subscribed {\n    background-color: #2e7d32; /* Green for subscribed */\n    color: white;\n  }\n  .subscribed:hover {\n    background-color: #1b5e20;\n    box-shadow: 0 2px 8px rgba(46, 125, 50, 0.4);\n  }\n  .unsubscribed {\n    background-color: #c62828; /* Red for unsubscribed */\n    color: white;\n  }\n  .unsubscribed:hover {\n    background-color: #b71c1c;\n    box-shadow: 0 2px 8px rgba(198, 40, 40, 0.4);\n  }\n    /* Pagination Controls */\n  .paginationContainer {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin: 20px 0;\n    gap: 15px;\n    padding-bottom: 10px;\n  }\n  .pageInfo {\n    color: #fff;\n    font-size: 14px;\n    min-width: 100px;\n    text-align: center;\n  }\n  .pageButton {\n    background-color: #3a3a3a;\n    color: white;\n    border: none;\n    padding: 10px 20px;\n    cursor: pointer;\n    border-radius: 5px;\n    transition: all 0.2s ease;\n    font-weight: 500;\n    min-width: 100px;\n  }\n  .pageButton:hover:not(.disabled) {\n    background-color: #555;\n    transform: translateY(-2px);\n  }\n  .pageButton:active:not(.disabled) {\n    transform: translateY(0);\n  }\n  .pageButton.disabled {\n    background-color: #1a1a1a;\n    cursor: not-allowed;\n    opacity: 0.5;\n  }\n  \n  /* Responsive Scroll for Small Screens */\n  @media (max-width: 768px) {\n    .headerCell,\n    .bodyCell {\n      font-size: 14px;\n      padding: 10px;\n    }\n  \n    .tableWrapper {\n      border-radius: 0;\n      box-shadow: none;\n      margin: 0 -10px;\n    }\n  \n    .paginationContainer {\n      flex-wrap: wrap;\n      justify-content: space-between;\n      padding: 0 10px 15px;\n    }\n    \n    .pageButton {\n      min-width: 80px;\n      padding: 8px 12px;\n    }\n    \n    .statusButton {\n      min-width: 100px;\n      padding: 6px 12px;\n      font-size: 13px;\n    }\n  }\n  \n  @media (max-width: 480px) {\n    .headerCell {\n      font-size: 13px;\n      padding: 8px;\n    }\n    .statusButton {\n      min-width: 90px;\n      padding: 5px 8px;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `NewsLetterPage_container__v8Ayy`,
	"tableWrapper": `NewsLetterPage_tableWrapper__9rKcl`,
	"table": `NewsLetterPage_table__c-DqW`,
	"headerRow": `NewsLetterPage_headerRow__BRokS`,
	"headerCell": `NewsLetterPage_headerCell__-yoJR`,
	"bodyRow": `NewsLetterPage_bodyRow__ssiqc`,
	"oddRow": `NewsLetterPage_oddRow__491Lp`,
	"evenRow": `NewsLetterPage_evenRow__8GPRv`,
	"bodyCell": `NewsLetterPage_bodyCell__asTp2`,
	"noData": `NewsLetterPage_noData__2PyoO`,
	"statusButton": `NewsLetterPage_statusButton__p0IGF`,
	"subscribed": `NewsLetterPage_subscribed__fyOmJ`,
	"unsubscribed": `NewsLetterPage_unsubscribed__9Msq2`,
	"paginationContainer": `NewsLetterPage_paginationContainer__NPmSb`,
	"pageInfo": `NewsLetterPage_pageInfo__PYARB`,
	"pageButton": `NewsLetterPage_pageButton__r9QoK`,
	"disabled": `NewsLetterPage_disabled__APyyN`
};
export default ___CSS_LOADER_EXPORT___;
